import {jsonParseQuiet} from 'extensions/utils/lib/json-parse-quiet';

/**
 * @param {Record<string, any>} pageContext
 */
const globalTracking = async (pageContext) => {
	const {TrackingService, PageType} = await import('extensions/hawksearch/services');

	// Create new tracking service
	const trackingService = new TrackingService({
		clientGuid: window.env.HAWK_SEARCH_CLIENT_GUID
	});

	// Track user logins
	if (pageContext.Action?.toLowerCase()?.includes('logn') && pageContext.Customer_ID > 0) {
		trackingService.trackMemberLogin();
	}

	// Track page views
	if (pageContext.Screen === 'PROD') {
		return trackingService.trackPageLoad(PageType.Item, pageContext.Product_Code);
	}

	if (pageContext.Screen === 'CTGY' && pageContext.HawkLandingPage) {
		return trackingService.trackPageLoad(PageType.Landing);
	}

	if (pageContext.Page_Code === 'BASK') {
		return trackingService.trackPageLoad(PageType.Cart);
	}

	if (pageContext.Page_Code === 'INVC') {
		// Track orders
		if (pageContext?.Order_ID > 0) {
			const order = jsonParseQuiet(pageContext.HawkOrder);
			if (order?.id) {
				trackingService.trackOrder(pageContext.Order_ID, order?.products, order?.subTotal, order?.tax, order?.total, 'USD');
			}
		}

		return trackingService.trackPageLoad(PageType.Order);
	}

	return trackingService.trackPageLoad(PageType.Custom);
};

/**
 * @param {string} productId
 * @param {number} quantity
 * @param {number} price
 */
export const addToCartTracking = async (productId, quantity, price) => {
	const {TrackingService} = await import('extensions/hawksearch/services');

	// Create new tracking service
	const trackingService = new TrackingService({
		clientGuid: window.env.HAWK_SEARCH_CLIENT_GUID
	});

	trackingService.trackAddToCart(productId, quantity, price, 'USD');
};

/**
 * @param {string} productId
 * @param {number} rating
 */
export const ratingTracking = async (productId, rating) => {
	const {TrackingService} = await import('extensions/hawksearch/services');

	// Create new tracking service
	const trackingService = new TrackingService({
		clientGuid: window.env.HAWK_SEARCH_CLIENT_GUID
	});

	trackingService.trackRating(productId, rating);
};

/**
 * @param {import('extensions/hawksearch/services/types').TrackingProduct[]} products
 */
export const addToCartMultipleTracking = async (products) => {
	const {TrackingService} = await import('extensions/hawksearch/services');

	// Create new tracking service
	const trackingService = new TrackingService({
		clientGuid: window.env.HAWK_SEARCH_CLIENT_GUID
	});

	trackingService.trackAddToCartMultiple(products);
};

/**
 * Dynamically create everything necessary for hawksearch to work globally
 */
export const bootstrapHawksearch = (pageContext) => {
	import('../components/autocomplete-app');
	import('../components/recommendations-app');

	// Run tracking scripts
	globalTracking(pageContext);
};

